import { CollideEvent, CollideId, isOneHitCollider } from '../../defs/collide';
import type { CoolerBlockEntity } from '../../entities/BlockEntity';
import { despawnBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { BreakEffect } from '../effects/BreakEffect';
import { CoolerEffect } from '../effects/CoolerEffect';
import { InvalidEffect } from '../effects/InvalidEffect';
import { CollideHandler, ICollision } from './ICollision';

export class CoolerCollision implements ICollision {
  private readonly scene: GameScene;
  private readonly entity: CoolerBlockEntity;
  private readonly resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this.resolveTap,
    block: this.resolveBlock,
    attack: this.resolveAttack,
  };

  constructor(scene: GameScene, entity: CoolerBlockEntity) {
    this.scene = scene;
    this.entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this.resolvers[event.id]?.call(this, event) ?? false;
  }

  private async resolveTap() {
    await new InvalidEffect(this.entity).execute();
    return false;
  }

  private async resolveBlock(event: CollideEvent) {
    await this.attack();
    return true;
  }

  private async resolveAttack(event: CollideEvent) {
    if (isOneHitCollider(event.collider?.type)) {
      this.entity.c.blockCooler.count = 0;
    }
    await this.attack();
    return true;
  }

  private async attack() {
    const entity = this.entity;
    const position = entity.c.position.mapPosition;
    const component = entity.c.blockCooler;

    // Ignore the attack if effect already triggered
    if (component.triggered) return;

    // Play the break effect
    new BreakEffect(this.scene, {
      position,
      size: entity.c.block.props,
      color: 0xb1bcca,
    }).execute();

    // If count is 0, despawn block, else decrement count
    if (component.count <= 0) {
      component.triggered = true;
      await new CoolerEffect(this.scene, entity).execute();
      despawnBlockEntity(this.scene, this.entity);
    } else {
      component.count -= 1;
      this.scene?.events.publish({ id: 'poke' });
    }
  }
}
